<template>
  <div class="mt-4 list-stage-planner">
    <div
      class="mb-6"
      v-for="(stageGroup, stageGroupIndex) in stages"
      :key="`stage-group-${stageGroupIndex}`"
    >
      <p class="border-bottom mb-4">
        <strong class="is-size-4">
          {{ stageGroup.dayName }}
        </strong>
        <strong class="is-size-5 ml-1">
          {{ stageGroup.age }}
        </strong>
        <span class="level-border-title ml-2" :style="`border-bottom-color: ${stageGroup.level.color_code}`">
          {{ stageGroup.level.name }}
        </span>
      </p>
      <div class="columns is-multiline">
        <div
          v-for="(stage, stageIndex) in stageGroup.stages"
          :key="`stage-${stageIndex}`"
          class="column is-4"
        >
          <stage-card
            :stage="stage"
            :day-name="stageGroup.dayName"
            :customers="customers"
            :customers-by-planned-stages="customersByPlannedStages"
            :add-stage-to-customer="addStageToCustomer"
            :remove-stage-to-customer="removeStageToCustomer"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { LocaleMixin } from "@/mixins/LocaleMixin";
import VueI18n from "vue-i18n";
import StageCard from "@/components/partial/stagesPlanner/StageCard";

export default {
  name: 'StagesList',
  components: { StageCard },
  mixins: [LocaleMixin],

  props: {
    plannedStages: {
      type: Array,
      required: true
    },
    customers: {
      type: Array,
      required: true
    },
    addStageToCustomer: {
      type: Function,
      required: true
    },
    removeStageToCustomer: {
      type: Function,
      required: true
    },
    customersByPlannedStages: {
      type: Object,
      required: true
    }
  },

  computed: {
    stages () {
      const orderedStages = {};
      for (const stage of this.plannedStages) {
        for (const day of stage.repetition_days) {
          let isoDay = day === "0" ? "7" : day
          const minAgeKey = stage.min_age < 10 ? `0${stage.min_age}` : stage.min_age;
          const maxAgeKey = stage.max_age < 10 ? `0${stage.max_age}` : stage.max_age;
          const plannedStageKey = `day-${isoDay}-level-${stage.level.order}-age-${minAgeKey}-${maxAgeKey}`;

          let age;
          if (stage.min_age >= 18) {
            age = `Adulte`;
          } else if (stage.min_age === stage.max_age) {
            age = `${stage.min_age} ans`;
          } else {
            age = `${stage.min_age}-${stage.max_age} ans`;
          }

          orderedStages[plannedStageKey] ||= {
            day,
            dayName: this.$t(`days.day${day}`),
            level: stage.level,
            age,
            stages: []
          };
          orderedStages[plannedStageKey].stages.push(stage);
        }
      }

      return Object.keys(orderedStages).sort().reduce(function (result, key) {
        result[key] = orderedStages[key];
        return result;
      }, {});
    }
  },

  // Translate component
  mounted () {
    this.$i18n.locale = this.getLocale();
  },
  i18n: new VueI18n({
    locale: "fr",
    messages: {
      en: {
        days: {
          0: "Sunday"
        },
      },
      fr: {
        days: {
          day0: "Dimanche",
          day1: "Lundi",
          day2: "Mardi",
          day3: "Mercredi",
          day4: "Jeudi",
          day5: "Vendredi",
          day6: "Samedi"
        },
      }
    }
  })
}
</script>

<style lang="scss">
.list-stage-planner {
  .level-border-title {
    padding: 30px 0 8px;
    position: relative;
    font-size: 1.2em;
    font-weight: bold;
    color: black;
    &::before {
      content: "";
      position: absolute;
      bottom: 10px;
      width: 106%;
      height: 1px;
      transform: skew(-37deg) translateX(-8%);
      border-bottom-style: solid;
      border-width: 8px;
      border-bottom-color: inherit;
      z-index: -1;
      border-radius: 2px;
    }
  }
}
</style>
